export const GET_LABELS_REQUEST = "GET_LABELS_REQUEST";
export const GET_LABELS_SUCCESS = "GET_LABELS_SUCCESS";
export const GET_LABELS_FAILURE = "GET_LABELS_FAILURE";

export const labelsInitialState: any = {
    labels: [],
    status: "EMPTY",
    error: null,
};

// Action creators
export const getLabelsRequest = () => ({
    type: GET_LABELS_REQUEST,
});

export const getLabelsSuccess = (labels: any) => ({
    type: GET_LABELS_SUCCESS,
    response: { data: labels },
});

export const getLabelsFailure = (error: any) => ({
    type: GET_LABELS_FAILURE,
    error,
});